import React from "react";
import Card from "@mui/material/Card";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AppointmentListController from "Controller/AppointmentListController";

function AppointmentList() {
  const {
    loading,
    appointmentRows,
    rowCount,
    paginationModel,
    setPaginationModel,
    columns,
    openDetailsPopup,
    handleCloseDetailsPopup,
    selectedAppointment,
    appointmentDetailRows,
    detailColumns,
    detailLoading,
  } = AppointmentListController();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <Card>
            <MDBox
              pt={2}
              px={2}
              mb={2}
              display="flex"
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "center" }}
              flexDirection={{ xs: "column", md: "row" }}
              gap={2}
            >
              <Box>
                <MDTypography variant="h6" fontWeight="medium">
                  Appointment List
                </MDTypography>
              </Box>
            </MDBox>

            <MDBox p={2}>
              <div style={{ width: "100%" }}>
                <DataGrid
                  rows={appointmentRows}
                  columns={columns}
                  loading={loading}
                  disableRowSelectionOnClick
                  pagination
                  paginationMode="server"
                  rowCount={rowCount}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[50]}
                  autoHeight
                  hideFooterSelectedRowCount
                  slotProps={{
                    pagination: {
                      labelRowsPerPage: "",
                    },
                  }}
                  sx={{
                    "& .MuiDataGrid-columnHeaders": {
                      fontWeight: "bold",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "1px solid #f0f0f0",
                      alignItems: "center",
                    },
                    "& .MuiTablePagination-selectLabel": {
                      display: "none",
                    },
                    "& .MuiTablePagination-input": {
                      display: "none",
                    },
                    "& .MuiTablePagination-select": {
                      display: "none",
                    },
                    "& .MuiTablePagination-selectIcon": {
                      display: "none",
                    },
                    "& .MuiTablePagination-spacer": {
                      display: "none",
                    },
                  }}
                />
              </div>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>

      <Dialog
        open={openDetailsPopup}
        onClose={handleCloseDetailsPopup}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "85vw",
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.25rem",
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          Appointment Details
          <Typography variant="body2" color="text.secondary">
            PO Number: {selectedAppointment?.poNumber || "-"}
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ width: "100%" }}>
            <DataGrid
              rows={appointmentDetailRows}
              columns={detailColumns}
              loading={detailLoading}
              disableRowSelectionOnClick
              autoHeight
              hideFooter
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  alignItems: "center",
                },
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCloseDetailsPopup}
            variant="outlined"
            sx={{
              color: "#6c757d",
              borderColor: "#6c757d",
              "&:hover": {
                backgroundColor: "#e9ecef",
                borderColor: "#6c757d",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default AppointmentList;
